import { ObjectList } from '../planboard/utils/objectlist';

/**
 * Important! Keep reference of initial elements while sorting. Otherwise delete action will break.
 * 
 * Recursively sorts an activity tree, currently based on the display name of the activity type then by activity id
 * @param tree Array with root level nodes of the tree to sort.
 * @param activityTypes ObjectList containing the activity types.
 * @returns The recursively sorted tree.
*/
export function sortActivityTree<
  T extends {
    id: number;
    activityTypeId: number;
    isHidden?: boolean;
    nodes?: T[];
  },
>(tree: T[], activityTypes: ObjectList): T[] {
  return tree
    .filter((item) => !item.isHidden)
    .sort((activityA, activityB) => {
      const activityTypeA = activityTypes.getObject(activityA.activityTypeId);
      const activityTypeB = activityTypes.getObject(activityB.activityTypeId);

      return (
        (activityTypeA?.sortOrder ?? 0) - (activityTypeB?.sortOrder ?? 0) ||
        activityA.id - activityB.id
      );
    })
    .map((item) => {
      if (item.nodes) {
        item.nodes = sortActivityTree(item.nodes, activityTypes);
      }

      return item;
    });
}
